import React, { useState } from 'react';
import { observer, inject } from 'mobx-react';
import SettingsField from '../SettingsField/SettingsField';
import './SettingsBlock.scss';

const SettingsBlock = inject("AllInputsStore", "AllInputsBlocksStore", "CookieStore")(observer((props) => {
  const inputs = props.AllInputsStore.inputs;
  const blocks = props.AllInputsBlocksStore.inputsBlocks;
  const cookie = props.CookieStore;
  const {blockName, methodName} = props;
  const {id, title, isFold, inputsNames} = props.data;
  const [isOpen, setIsOpen] = useState(true);


  const settingsBlockBaseClass = 'settings-block';
  const settingsBlockClass = () => title ? `${settingsBlockBaseClass} ${settingsBlockBaseClass}_title` : `${settingsBlockBaseClass}`;

  function renderFoldingBtn() {
    if(!isFold) return null;
    const btnClass = () => isOpen ? `${settingsBlockBaseClass}__folding-btn_open` : `${settingsBlockBaseClass}__folding-btn_close`;
    return (
      <span
        onClick={() => setIsOpen(!isOpen)}
        className={`${settingsBlockBaseClass}__folding-btn ${btnClass()}`}>
      </span>
    )
  }

  const isDisplayInput = (name) => {
    return true;
  };


  const renderHeader = () => {
    if(!title) return null;
    return (
      <div className={`${settingsBlockBaseClass}__header`}>
        <h3 className={`${settingsBlockBaseClass}__title`}>{ title }</h3>
        {renderFoldingBtn()}
        <hr className={`${settingsBlockBaseClass}__split-line`}/>
      </div>
    )
  };

  const renderSettingsFields = () => {
    const inputList = inputsNames.map((name, index) => {
      if(isDisplayInput(name) === 'false') return null;
      return (
          <SettingsField blockName={blockName} name={name} key={index}/>
      )
    });
    return isOpen ? inputList : null;
  };

  return (
    <div className={settingsBlockClass()}>
      { renderHeader() }
      <div className={`${settingsBlockBaseClass}__settings`}>
        { renderSettingsFields() }
      </div>
    </div>
  );
}));

export default SettingsBlock;
